import React from "react";
import PropTypes from "prop-types";

const SkeletonElement = ({ type }) => {
  const classes = `skeleton__${type}`;
  return (
    <>
      <div className="skeleton">
        <div className={classes}></div>
      </div>
    </>
  );
};

export default SkeletonElement;

SkeletonElement.propTypes = {
  type: PropTypes.string
};

